<template>
  <div>
    <div class="card">
      <h1 class="title-card-text-style">{{title}}</h1>
      <div class="card-content">
        <div class="content">
          <div class="slot-style">
            <slot></slot>
          </div>
        </div>
        <p class="note-style">{{note}}</p>
        <p class="dateTime-style">Update at {{datetime}}</p>
      </div>
      <!-- <footer v-if="title" class="card-footer">
        <a
        @click=""
          class="card-footer-item"
        >export</a>

      </footer> -->
    </div>
  </div>
</template>

<script>

export default {

  props: ['title', 'datetime', 'note'],
  data () {
    return {
    }
  }
}

</script>

<style>

.title-card-text-style {
  padding-top: 10px;
  font-size: 25px;
  }

.table-text-style{
  font-size: 15px;
}

.dateTime-style{
  font-size: 10px;
  color: #2D2B74;
}

.note-style{
  font-size: 12px;
  color: #742b31;
}

</style>
